import { H3 } from 'foundations-components/transitional/components/H3';
import { Section } from 'foundations-components/transitional/components/Section';
import ExamFinishedSecondaryButtons from './ExamFinishedSecondaryButtons';
import PracticalExercisesOutstanding from './PracticalExercisesOutstanding';
import { View } from 'foundations-components/components/View';
import FinishedContainer from '../../../components/FinishedContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamFinishedScreenLayout = ({
  illustration,
  heading,
  subheading,
  prompt,
  callToAction,
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises,
  showSecondaryRetakeCTA
}) => {
  const body = /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      "data-test-id": "exam-finished-screen-heading",
      children: heading
    }), /*#__PURE__*/_jsx(Section, {
      "data-test-id": "exam-finished-screen-subheading",
      children: subheading
    }), prompt && /*#__PURE__*/_jsx(Section, {
      children: prompt
    }), callToAction && /*#__PURE__*/_jsx(Section, {
      "data-test-id": "exam-finished-screen-primary-ctas",
      children: callToAction
    }), /*#__PURE__*/_jsx(PracticalExercisesOutstanding, {
      pendingPracticalExercises: pendingPracticalExercises,
      trackId: track.id
    })]
  });
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: body,
    footer: /*#__PURE__*/_jsx(ExamFinishedSecondaryButtons, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      retake: showSecondaryRetakeCTA,
      track: track
    }),
    illustration: illustration
  });
};
export default ExamFinishedScreenLayout;